import {useEffect, useRef} from "react";
import {useFormContext} from "react-hook-form";
import {FILE_TYPE} from "components/material/view/info/FileAttachmentForm/types";

interface MultiFileAttachProps {
    source?: string;
    label?: string;
    disabled?: boolean;
    fileType?: FILE_TYPE;
    getFileData?: (file: File) => Record<string, unknown>;
}

const MultiFileAttach = ({
                             source = "files",
                             label = "Добавить несколько файлов",
                             disabled = false,
                             fileType = FILE_TYPE.REGULAR,
                             getFileData,
                         }: MultiFileAttachProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { getValues, setValue } = useFormContext();

    useEffect(() => {
        function onWinDragOver(e: DragEvent) {
            e.preventDefault();
        }

        window.addEventListener('dragover', onWinDragOver);
        return () => {
            window.removeEventListener('dragover', onWinDragOver);
        };
    }, []);

    function onAreaClick() {
        if (disabled) return;
        inputRef.current?.click();
    }

    function onUpload(newFiles: FileList) {
        if (disabled) return;

        for (const newFile of Array.from(newFiles)) {
            const formFiles = getValues(source) || [];
            const documentName = newFile.name.replaceAll(/(\.[^.$]+)$/g, '')
            const newFormFile = {
                ...getFileData?.(newFile),
                name: documentName,
                fileType,
                file: {
                    rawFile: newFile,
                    title: newFile.name,
                    src: {
                        name: newFile.name,
                    }
                }
            };
            setValue(source, [...formFiles, newFormFile], {
                shouldTouch: true,
                shouldDirty: true
            });
        }
    }

    function onAreaDrop(e: React.DragEvent) {
        e.preventDefault();
        if (disabled) return;
        onUpload(e.dataTransfer.files);
    }

    function onAreaDragOver(e: React.DragEvent) {
        e.preventDefault();
        if (disabled) return;
        e.dataTransfer.dropEffect = 'copy';
    }

    function onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (inputRef?.current?.files != null) {
            onUpload(inputRef?.current?.files);
        }
    }

    return <section className="multi-file-attach" data-disabled={disabled} onClick={onAreaClick} onDragOver={onAreaDragOver} onDrop={onAreaDrop}>
        <input className="multi-file-attach__input" ref={inputRef} type="file" multiple={true} disabled={disabled} onChange={onInputChange}></input>
        {label}
    </section>
};

export default MultiFileAttach;
